import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SeoService } from '../../../core/services/seo.service';

@Component({
  selector: 'app-ueber-uns',
  standalone: true,
  imports: [RouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './ueber-uns.component.html',
  styleUrl: './ueber-uns.component.scss',
})
export class UeberUnsComponent {
  constructor() {
    inject(SeoService).apply({
      title: 'Über uns · Craftly',
      description:
        'Wer hinter Craftly steht: Valentin und Thore aus Düsseldorf. Mission, Werte und Unternehmensdaten der Kulatrix UG.',
      path: '/ueber-uns',
      type: 'article',
    });
  }
}
